import axios, { AxiosRequestConfig, AxiosResponse, HttpStatusCode } from "axios"
import { getValidationError } from "../pages/shared/utilitties/getValidationError"
import { STORAGE_LOCAL } from "../pages/shared/models/storages"
export const AxiosInterceptor = () => {
    const updateHeader = (request:AxiosRequestConfig) => {
        const token = window.localStorage.getItem(STORAGE_LOCAL.TOKEN)
        const newHeaders = {
            Authorization : token,
            "Content-type": "application/json",
        }
        request.headers = newHeaders;
        return request
    }

    axios.interceptors.request.use((request:any) => {
        if(request.url?.includes("Login")) return request;
        return updateHeader(request)
    })

    axios.interceptors.response.use(
        (response) => {
            //console.log("response", response) 
            return response
        },
        (error) => {
            //console.log("error", getValidationError(error.code))
            //SnackbarUtilities.error(getValidationError(error.code))
            if(error.response.status == HttpStatusCode.TooManyRequests){
                return error.response
            }
            if(error.response.status == HttpStatusCode.Unauthorized){
                if( window.location.href !== error.response.data.nologin)
                    window.location.replace(error.response.data.nologin);
            }
            return Promise.reject(error.response)
        }
    )
}